/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Filter_Has_DebtInputs */

const vi_customer_debt_filter_has_debt = /** @type {(inputs: Customer_Debt_Filter_Has_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn nợ`)
};

/**

* @param {Customer_Debt_Filter_Has_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_filter_has_debt = /** @type {((inputs?: Customer_Debt_Filter_Has_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Filter_Has_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_filter_has_debt(inputs)
});